module.exports = __webpack_public_path__ + "static/media/z&v10.fccdb0f3.jpg";